import * as React from 'react'
import { Button, StyleSheet, Text, View } from 'react-native'
import { useAuthStore } from '../../../stores/auth'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { en as welcomeEn } from '../../../i18n/WelcomeScreen'
import { useInitializeStore } from '../../../stores/initialize'

export default function Loginerror() {

  const { logout } = useAuthStore()
  const { errorCode, error } = useInitializeStore()
  const handleModal = () => {
    logout()
    AsyncStorage.removeItem('@Auth')
    AsyncStorage.removeItem('selectedLanguage')
    AsyncStorage.removeItem('EXPO_CONSTANTS_INSTALLATION_ID')
  }



  React.useEffect(() => {
    if (error) {
      handleModal();
    }
  }, []);


  return (
    <View style={styles.container}>
      {/* <Text style={styles.title}>{welcomeEn.loginError}</Text>
      <Text style={styles.title}>{welcomeEn.loginError2}</Text>
      <View style={styles.separator} />
      <Button title="Login" onPress={handleModal} /> */}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  text: {
    fontSize: 16,
    fontWeight: '400',
    textAlign: 'center'
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%'
  }
})
